import defaultState from './state'
import Vue from 'vue'

export default {
  setNewExpense: (state, payload) => {
    state.newExpense = payload
  },
  setTransactions: (state, payload) => {
    let transactions = new Map()
    if (state.currentPage === 1) {
      payload.map(obj => transactions.set(obj.id, obj))
    } else {
      state.transactions.map(obj => transactions.set(obj.id, obj))
      payload.map(obj => transactions.set(obj.id, obj))
    }
    state.transactions = [...transactions].map(([name, value]) => value)
  },
  setUsers: (state, payload) => {
    state.usersCurrentPage === 1
      ? (state.users = payload)
      : state.users.push(...payload)
  },
  setCurrentTransaction: (state, payload) => {
    state.currentTransaction = payload
  },
  updateTransaction: (state, payload) => {
    const { id } = payload
    const transactionToUpdateIndex = state.transactions.findIndex(
      el => el.id === id
    )
    if (transactionToUpdateIndex !== -1) {
      state.transactions.splice(transactionToUpdateIndex, 1, payload)
    } else {
      state.transactions.push(payload)
    }
  },
  addTransactionReceipt: (state, payload) => {
    const { id } = payload
    const transactionToUpdateIndex = state.transactions.findIndex(
      el => el.id === id
    )
    if (transactionToUpdateIndex !== -1) {
      let transaction = state.transactions[transactionToUpdateIndex]
      transaction.receipts.push(payload.receipt)
    }
  },
  deleteTransaction: (state, payload) => {
    state.transactions = state.transactions.filter(el => el.id !== payload)
  },
  setTransactionsTotalItems: (state, payload) => {
    state.totalItems = payload
  },
  incrementTransactionsCurrentPage: state => {
    state.currentPage++
  },
  setTransactionsLastPage: (state, payload) => {
    state.lastPage = payload
  },
  setLoadingTransactions: (state, payload) => {
    state.isLoadingTransactions = payload
  },
  setLoadingNextPageTransactions: (state, payload) => {
    state.isLoadingNextPageTransactions = payload
  },
  setTransactionsFilters: (state, payload) => {
    state.filters = payload
    state.currentPage = 1
  },
  setUserSelectedFiltersAmount: (state, payload) => {
    state.userSelectedFiltersAmount = payload
  },
  resetUserSelectedFiltersAmount: (state) => {
    state.userSelectedFiltersAmount = 0
  },
  setTableColumns: (state, payload) => {
    state.tableColumns = payload
  },
  setTableExportColumns: (state, payload) => {
    state.tableExportColumns = payload
  },
  setUserPaymentMethods: (state, payload) => {
    state.userPaymentMethods = [...payload]
  },
  setOfficePaymentMethods: (state, payload) => {
    payload.forEach(item => {
      item.editable = false
    })
    state.officePaymentMethods = [...payload]
  },
  updateSelectedTransactions: (state, payload) => {
    const transactionToCheckIndex = state.selectedTransactions.findIndex(
      el => el.id === payload.id
    )
    if (transactionToCheckIndex !== -1) {
      state.selectedTransactions.splice(transactionToCheckIndex, 1)
    } else {
      state.selectedTransactions.push(payload)
    }
  },
  updateSelectedUsers: (state, payload) => {
    const userToCheckIndex = state.selectedUsers.findIndex(
      el => el.user_id === payload.user_id
    )
    if (userToCheckIndex !== -1) {
      state.selectedUsers.splice(userToCheckIndex, 1)
    } else {
      state.selectedUsers.push(payload)
    }
  },
  markTransactionAsProcessing: (state, payload) => {
    let transactionToSetAsProcessingIndex = state.transactions.findIndex(el => el.id === payload)
    if (transactionToSetAsProcessingIndex > -1) {
      state.transactions[transactionToSetAsProcessingIndex].processing = true
    }
  },
  toggleSelectAll: (state, value) => {
    state.selectAllFlag = value
  },
  toggleSelectAllUsers: (state, value) => {
    state.selectAllFlag = value
  },
  setAllTransactionsAsSelected: (state, payload) => {
    // const transactions = payload.map(el => { return { id: el.id } })
    state.selectedTransactions = [...payload]
  },
  setAllUsersAsSelected: (state, payload) => {
    state.selectedUsers = [...payload]
  },
  clearSelectedTransactions: state => {
    state.selectedTransactions = []
  },
  clearSelectedUsers: state => {
    state.selectedUsers = []
  },
  setUserPaymentMethodsFilters: (state, payload) => {
    state.userPaymentMethodsFilters = payload
  },
  setCurrentExpenseReceipts: (state, payload) => {
    state.currentExpenseReceipts.push(...payload)
  },
  removeCurrentExpenseReceipt: (state, payload) => {
    let receiptToRemove = state.currentExpenseReceipts.findIndex(
      el => el.id === payload
    )

    if (receiptToRemove > -1) {
      state.currentExpenseReceipts = state.currentExpenseReceipts.filter(
        el => el.id !== payload
      )
    }
  },
  setTopBanner: (state, payload) => {
    state.topBanner = payload
  },
  setTransactionDashboard: (state, payload) => {
    state.transactionDashboard = payload
  },
  setTransactionsWithoutFiltersDashboard: (state, payload) => {
    state.transactionsWithoutFiltersDashboard = payload
  },
  setIsCallingTransactionDashboard: (state, payload) => {
    state.isCallingTransactionDashboard = payload
  },
  setIsCallingTransactionsDashboardWithoutFilters: (state, payload) => {
    state.isCallingTransactionDashboardWithoutFilters = payload
  },
  resetExpenseReceipts: state => {
    state.currentExpenseReceipts = []
  },
  setReceiptModalIsOpen: (state, payload) => {
    state.receiptModalIsOpen = payload
  },
  setTransactionReviewBarIsShown: (state, payload) => {
    state.transactionReviewBarIsShown = payload
  },
  setTransactionMissingInfoBarIsShown: (state, payload) => {
    state.transactionMissingInfoBarIsShown = payload
  },
  setExpensesValue: (state, payload) => {
    state.expenses = payload
  },
  setSelectedTransactionsBulkAction: (state, payload) => { state.selectedTransactionsBulkAction = payload },
  setSelectedUsersBulkAction: (state, payload) => { state.selectedUsersBulkAction = payload },
  incrementUsersCurrentPage: (state) => {
    state.usersCurrentPage++
  },
  setUsersLastPage: (state, payload) => {
    state.usersLastPage = payload
  },
  setUsersTotalItems: (state, payload) => {
    state.setUsersTotalItems = payload
  },

  setVatTypes: (state, payload) => { state.vatTypes = payload },
  setReceiptUploadingByDragAndDrop: (state, payload) => {
    state.receiptUploadingByDragAndDrop = payload
  },
  loadFilteredViews: (state, payload) => {
    state.filteredViews = [...payload]
  },
  addFilteredView: (state, payload) => {
    state.filteredViews.push(payload)
    localStorage.setItem('quickFilters', JSON.stringify(state.filteredViews))
  },
  editFilteredView: (state, payload) => {
    const { id } = payload
    const filteredViewToEditIndex = state.filteredViews.findIndex(el => el.id === id)
    if (filteredViewToEditIndex > -1) {
      let updatedFilteredView = { ...state.filteredViews[filteredViewToEditIndex] }

      updatedFilteredView = { ...payload }

      state.filteredViews.splice(filteredViewToEditIndex, 1, updatedFilteredView)
      localStorage.setItem('quickFilters', JSON.stringify(state.filteredViews))
    }
  },
  incrementFilteredViewBaseId: state => {
    state.filteredViewBaseId++
  },
  setFilteredViewBaseId: (state, payload) => {
    state.filteredViewBaseId = payload
  },
  removeFilteredView: (state, payload) => {
    const filteredViewIdToRemoveIndex = state.filteredViews.findIndex(el => el.id === payload)

    if (filteredViewIdToRemoveIndex > -1) {
      state.filteredViews.splice(filteredViewIdToRemoveIndex, 1)
      localStorage.setItem('quickFilters', JSON.stringify(state.filteredViews))
    }
  },
  setCurrentFilteredView: (state, payload) => {
    if (payload?.id) {
      const { id } = payload
      const selectedFilteredView = state.filteredViews.find(el => el.id === id)
      state.currentFilteredView = { ...selectedFilteredView }
    } else {
      state.currentFilteredView = {}
    }
  },
  _removeAccountableFilters: (state) => {
    const accountableFilters = [
      'card.user.id',
      'absAmount[gte]',
      'absAmount[lte]',
      'isCompleted',
      'reviewStatus.code',
      'withWarnings',
      'expense.paymentMethod.officePaymentMethod.id',
      'budget.id',
      'defaultCategory.id',
      'customCategory.id',
      'card.office.customer.id',
      'receipt.accountingDate[after]',
      'receipt.accountingDate[before]',
      'withReviewFlow',
      'reviewStatusAndNextFlowStepId',
      'reviewStatusAndNextFlowStepId',
      'receipt.taxBase1[gt]',
      'receipt.taxBase2[gt]',
      'receipt.taxBase3[gt]',
      'receipt.taxBase4[gt]',
      'receipt.type'
    ]
    accountableFilters.forEach(el => {
      if (el in state.filters) {
        delete state.filters[el]
      }
    })
  },
  clearTransactions: (state) => {
    state.filters = {}
    state.transactions = []
    state.selectedTransactions = []
    state.selectedUsers = []
    state.selectAllFlag = false
    state.selectedTransactionsBulkAction = false
    state.selectedUsersBulkAction = false
    state.currentPage = 1
    state.lastPage = 1
    state.totalItems = 0
  },
  clearCurrentTransaction: (state) => {
    state.currentTransaction = {}
  },
  clearFilters: (state) => {
    state.filters = Object.assign({}, { 'date[after]': state.filters['date[after]'], 'date[before]': state.filters['date[before]'] })
  },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      if (key === 'tableColumns') return
      Vue.set(state, key, initialState[key])
    })
  }
}
